import styled from "styled-components";

export const Container = styled("div")`
	width: 90%;
	height: 50px;
	background: #fff;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	//margin: 0.9em;
	font-size: 0.6rem;
	//font-size: 0.8em;
`;
